<template>
  <div class="hidden"/>
</template>

<script>
/* global triggerOmnitureInteractions */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      interactionType: state => state.LP.interactionType,
      // loadingQuestionData: state => state.LP.flags.loadingQuestionData,
      categoryId: state => state.LP.GSGo.categoryId,
      indicatorId: state => state.LP.indicatorId,
      stratFilters: state => state.LP.stratFilters,
      view: state => state.LP.view,
      lku: state => state.lku,
      showFootnotes: state => state.LP.flags.showFootnotes,
      mapClassifierId: state => state.LP.mapClassifierId,
      mapClassifierCount: state => state.LP.mapClassifierCount,
    }),
    stratFiltersCsv() {
      const sf = this.stratFilters;
      return `${sf.indicatorId},${sf.stratCatId1},${sf.stratId1},${sf.stratCatId2},${sf.stratId2},${sf.responseId},${sf.yearId}`;
    },
  },
  watch: {
    stratFiltersCsv(val, oldVal) {
      const { interactionType } = this;
      // console.log('stratFilters watch', this.interactionType);
      // console.log(oldVal);
      // console.log(val);
      if (interactionType === 'IS' || interactionType === 'II' || interactionType === 'IV') {
        this.triggerInteraction(interactionType);
      } else {
        // determine what stratification dropdown changed by comparing oldVal to val
        const mapping = {
          stratCatId1: 1,
          stratId1: 2,
          stratCatId2: 3,
          stratId2: 4,
          responseId: 5,
          yearId: 6,
        };
        const vals = val.split(',');
        const oldVals = oldVal.split(',');
        if (vals[mapping.stratCatId1] !== oldVals[mapping.stratCatId1]
          || vals[mapping.stratId1] !== oldVals[mapping.stratId1]
          || vals[mapping.stratCatId2] !== oldVals[mapping.stratCatId2]
          || vals[mapping.stratId2] !== oldVals[mapping.stratId2]
        ) {
          this.triggerInteraction('IST');
        } else if (vals[mapping.responseId] !== oldVals[mapping.responseId]) {
          this.triggerInteraction('IR');
        } else {
          this.triggerInteraction('IY');
        }
      }
      this.$store.commit('LP/resetInteractionType');
    },
    interactionType(val) {
      // handle interactionType changes that don't cause stratFiltersCsv to change
      if (val === 'IVNoUpdate'
        || val.substr(0, 2) === 'IB'
        || val === 'IML'
        || val.substr(0, 2) === 'IE') {
        // console.log('interactionType watch', val, this.stratFiltersCsv, performance.now());
        let interactionType = val;
        if (interactionType === 'IVNoUpdate') interactionType = 'IV';
        this.triggerInteraction(interactionType);
        this.$store.commit('LP/resetInteractionType');
      }
    },
  },
  methods: {
    triggerInteraction(interactionType) {
      const {
        categoryId, indicatorId, mapClassifierId, mapClassifierCount, showFootnotes,
      } = this;
      const view = this.view.substr(0, 1);
      const { stratCatId1, stratCatId2, yearId } = this.stratFilters;
      let { stratId1, stratId2, responseId } = this.stratFilters;
      stratId1 = stratId1 || 'All';
      stratId2 = stratCatId2 && stratId2 === '' ? 'All' : stratId2;
      responseId = responseId || 'All';
      const year = this.lku.Year[yearId].name;
      const footnotes = showFootnotes ? 'Y' : 'N';

      let interactionString;
      switch (interactionType) {
        case 'IS':
          interactionString = `${interactionType} ${categoryId}`;
          break;
        case 'II':
          interactionString = `${interactionType} ${indicatorId},${categoryId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        case 'IB SF':
        case 'IB HF':
        case 'IB DG':
          interactionString = `${interactionType},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        case 'IV':
          interactionString = `${interactionType} ${view},${categoryId},${indicatorId},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        case 'IY':
          interactionString = `${interactionType} ${year},${categoryId},${indicatorId},${view},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        case 'IR':
          interactionString = `${interactionType} ${responseId},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2}`;
          break;
        case 'IST':
          interactionString = `${interactionType} ${stratCatId1},${stratId1},${stratCatId2},${stratId2},${categoryId},${indicatorId},${view},${year},${responseId}`;
          break;
        case 'IML':
          interactionString = `${interactionType} ${mapClassifierId},${mapClassifierCount},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        case 'IE PDF':
        case 'IE EX':
          interactionString = `${interactionType},${footnotes},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`;
          break;
        default:
          throw new Error(`Unexpected interactionType: ${interactionType}`);
      }
      interactionString = `${process.env.InteractionIdentifier}-${interactionString}`;
      // console.log(interactionString);
      triggerOmnitureInteractions(interactionString);
    },
  },
};
</script>

<style scoped>
  .hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/Interactions.vue